import moment from 'moment';

const StatusTicks = ({ interaction }) => {
  const { type, date, status } = interaction;

  const baseClass = 'inline-block align-middle';

  const Check = ({ className = '' }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' className={`w-3 h-3 ${className}`} fill='currentColor'>
      <path d='M9.55 17.04a1 1 0 0 1-1.41 0l-3.18-3.18a1 1 0 1 1 1.41-1.41l2.47 2.47 7.18-7.18a1 1 0 1 1 1.41 1.41L9.55 17.04z' />
    </svg>
  );

  const renderStatusTicks = status => {
    if (status === 'seen') {
      return (
        <span className={`${baseClass} ml-1 text-blue-400`}>
          <span className='relative inline-flex'>
            <Check />
            <span className='-ml-1'>
              <Check />
            </span>
          </span>
        </span>
      );
    }
    if (status === 'reached') {
      return (
        <span className={`${baseClass} ml-1`}>
          <span className='relative inline-flex'>
            <Check className='opacity-90' />
            <span className='-ml-1'>
              <Check className='opacity-90' />
            </span>
          </span>
        </span>
      );
    }
    if (status === 'sent') {
      return (
        <span className={`${baseClass} ml-1`}>
          <Check className='opacity-90' />
        </span>
      );
    }
    // Meta avisa de los envíos que no llegan. Sin esto se quedaban con el tick
    // de «enviado», o sea diciendo que había salido bien, que es lo contrario
    // de lo que pasó — y en esta pantalla es donde se decide si insistir.
    if (status === 'failed') {
      return (
        <span className={`${baseClass} ml-1 text-red-500 font-medium`} title='No se pudo entregar'>
          no entregado
        </span>
      );
    }
  };

  return (
    <div className={`text-xs mt-1 ${type === 'whatsapp_sent' ? 'text-gray-500' : 'text-gray-400'}`}>
      <span>{moment(date).format('HH:mm')}</span>
      {type === 'whatsapp_sent' && renderStatusTicks(status)}
    </div>
  );
};

export default StatusTicks;
